import React from 'react';

import { useResources } from 'features/resources';
import { DashboardView as DashboardNewView, useSheets } from 'features/dashboard-new';
import DashboardOldView from './Dashboard2';

const DashboardCheck = (): React.ReactElement => {
  const { forceOldDashboard } = useSheets();
  const { usingNewDashboard } = useResources();

  return usingNewDashboard && !forceOldDashboard ? <DashboardNewView /> : <DashboardOldView />;
};

export default DashboardCheck;
